
export default {
    productData: {
        serialNumber: 'DA-HMS-003',
        name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 3',
        construction: {
            composition: [
                {
                    type: 'screed',
                    title: { de: 'Estrich' },
                    output: 'ohne',
                    value: 'nw-0'
                },
                {
                    type: 'soundInsulation',
                    title: { de: 'Schalldämmplatte' },
                    output: '2 x 15 mm',
                    value: 'si-30'
                },
                {
                    type: 'insulation',
                    title: { de: 'Holzfaserdämmplatte' },
                    output: '≥ 20',
                    value: 'w-20'
                },
                {
                    type: 'fill',
                    title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 132 kg/m<sup>2</sup>), Rieselschutz' },
                    output: '≥ 80',
                    value: 'scsb-80'
                },
                {
                    type: 'woodenPanel',
                    title: { de: 'Holzwerkstoffplatte HW' },
                    output: '≥ 22',
                    value: 22
                },
                {
                    type: 'supportingStructure',
                    title: { de: 'Balken' },
                    output: '240',
                    value: 'b-240'
                },
                {
                    type: 'suspendedCeiling',
                    title: { de: 'Hohlraumdämpfung' },
                    output: '2 x 120',
                    value: 'h-240'
                  },
                {
                    type: 'suspendedCeiling',
                    title: { de: 'Lattung' },
                    output: '24',
                    value: 'ba-24'
                },
                {
                    type: 'suspendedCeiling',
                    title: { de: 'Gipsplatte GKFI' },
                    output: '12,5',
                    value: 'g-12.5'
                  }
                ],
                sum: {
                    output: '429', value: 429
                }
                },
                technicalValues: {
                impactSoundLevel: { // L,nw
                    output: '56 (2; 3)',
                    value: 56
                },
                soundReductionIndex: { // Rw
                    output: '66 (-4; -11)',
                    value: 66
                },
                heatTransferCoefficient: { // U-Wert
                    output: '0,18',
                    value: 0.18
                },
                fireResistance: {
                output: '-',
                value: null
                },
                massPerUnitArea: {
                output: '229,7 [kg/m²]'
                }
             }
        },
    image: 'da-hms-003.png',
    pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-3-DA-HMS-003-Rev01.pdf'
    }
  
